import { switchElements } from '../../../shared/js/helpers/switchElements';
import { executeOnDocumentReady } from '../../../utils';

export default function () {
	window.addEventListener('click', function (e) {
		const switched = switchElements(e, 'candidate-popup-main-button-switchable', 'flex');
		if (!switched) {
			switchElements(e, 'candidate-popup-switchable', 'flex');
		}
	});

	executeOnDocumentReady(() => {
		Array.from(document.getElementsByClassName('candidate-popup-button')).forEach((element) =>
			element.addEventListener('click', (e) => {
				const wrapper = e.currentTarget.closest('.candidate-popup-wrapper');
				if (wrapper) {
					wrapper.style.display = 'none';
				}
			})
		);
	});
}
